<template>
  <div class="active-advertisers">
    <v-layout row wrap fill-height>
      <v-flex xs12 class="menu-column hidden-xs-and-down">
        <Header />
      </v-flex>

      <v-flex xs12 class="div-container-activeadvertisers-card">
        <v-layout row wrap v-if="!loading" class="div-actives-advertisers">

          <v-flex xs12 class="mb-4">
            <h2 :style="{ color: $vuetify.dark ? '#40DA99' : '#2D2F32' }">Cupons</h2>
          </v-flex>

          <v-layout row wrap v-if="filteredCoupons.length > 0">
            <v-flex xs12 sm12 md12 v-for="action in filteredCoupons" :key="action._id">
              <div class="div-container">
                <div class="div-each-advertiser-bond">

                  <div class="div-layout-information-advertiser-bond">
                    <div class="div-logo-advertiser">
                      <img v-if="action.anunciante && action.anunciante.length" :src="action.anunciante[0].img_logo"
                        alt="Logo Anunciante">
                    </div>

                    <div class="div-information-each-advertiser">
                      <p class="paragrafo-name" v-if="action.anunciante && action.anunciante.length">
                        {{ action.anunciante[0].register ? action.anunciante[0].register.reg_name :
                          action.anunciante[0].name_tag }}
                      </p>
                      <p class="paragrago-campaign">{{ action.name }}</p>

                      <div class="div-cupom-destaque">
                        <span class="label-cupom">CUPOM:</span>
                        <span class="codigo-cupom">{{ action.cupom }}</span>
                      </div>
                    </div>
                  </div>

                  <div class="div-buttons-advertisers">
                    <button @click="handleCopyCupom(action.cupom)" v-clipboard:copy="action.cupom">
                      Copiar Cupom
                    </button>
                    <a :href="action.links[0].url" target="_blank" class="mt-2">
                      Ir para Loja
                    </a>
                  </div>

                </div>
              </div>
            </v-flex>
          </v-layout>

          <v-layout row wrap v-else>
            <v-flex xs12 sm12 md12 class="container-without-shops">
              <div class="container-without-advertiser">
                <p>Nenhum cupom disponível no momento.</p>
              </div>
            </v-flex>
          </v-layout>

          <v-flex xs12 class="text-xs-center mt-4 mb-4">
            <v-pagination color="#40DA99" v-model="page" :length="totalPages" circle></v-pagination>
          </v-flex>

        </v-layout>

        <v-layout row wrap v-else>
          <v-flex xs12 sm12 md12 class="div-loading-circle">
            <v-progress-circular indeterminate color="#40DA99"></v-progress-circular>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import axios from 'axios'
import Header from '../components/Header.vue'
import { affiliate_api } from '@/api'

export default {
	name: 'CouponsPage',
	mixins: [affiliate_api],
	components: { Header },
	data() {
		return {
			loading: false,
			actions: [],
			page: 1,
			totalPages: 1,
		}
	},
	computed: {
		filteredCoupons() {
			return this.actions.filter(a => a.cupom && a.cupom.trim() !== '')
		}
	},
	methods: {
		async load_coupons() {
			let magauser = localStorage.getItem('magauser')
			if (magauser) {
				this.loading = true
				try {
					const params = new URLSearchParams()
					params.append('page', this.page)

					let response = await axios.get(`/api/affiliates/${magauser}/actions_all/`, {
						auth: {
							username: localStorage.getItem('mgf_login'),
							password: localStorage.getItem('mgf_password'),
						},
						params: params
					})

					this.actions = response.data.entries
					this.totalPages = Math.round(response.data.total / response.data.limit + 0.4)

				} catch (err) {
					// console.error('Erro ao carregar cupons:', err)
				}
				this.loading = false
			}
		},
		handleCopyCupom(code) {
			this.$notify({
				type: 'success',
				title: 'Copiado!',
				text: `Cupom ${code} copiado com sucesso.`
			})
		}
	},
	watch: {
		page() {
			this.load_coupons()
		}
	},
	created() {
		this.load_coupons()
	}
}
</script>

<style scoped>
div.active-advertisers {
  margin: 55px 10px 95px 10px;
}

/* CONTAINER PRINCIPAL ALINHADO */
.div-container-activeadvertisers-card {
  padding-left: 20px !important;
  width: 100% !important;
  max-width: 100% !important;
}

.div-actives-advertisers {
  margin-top: 20px;
  padding: 12px;
}

.div-loading-circle {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 80vh;
}

.div-actives-advertisers .div-container {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  margin: 15px 0px;
  padding: 0;
  /* Removido padding extra que estreitava o card */
  width: 100%;
}

.div-each-advertiser-bond {
  display: flex;
  align-items: center;
  justify-content: space-between;
  /* Melhor distribuição */
  padding: 20px;
  border-radius: 16px;
  width: 100%;
  transition: 0.3s;
}

.div-layout-information-advertiser-bond {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex: 1;
}

.div-logo-advertiser {
  box-sizing: border-box;
  border-radius: 50%;
  width: 80px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 25px;
  background: #FBFBFB;
  padding: 10px;
  flex-shrink: 0;
  /* Impede o logo de encolher */
}

.div-logo-advertiser img {
  max-width: 60px;
  max-height: 40px;
  object-fit: contain;
}

.div-information-each-advertiser {
  text-align: left;
  flex: 1;
}

.div-information-each-advertiser p.paragrafo-name {
  font-weight: 700;
  font-size: 18px;
  margin: 0px;
  text-transform: uppercase;
}

.div-information-each-advertiser p.paragrago-campaign {
  font-size: 13px;
  margin: 4px 0px 10px 0px;
  opacity: 0.7;
  line-height: 1.2;
}

.div-cupom-destaque {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 5px;
}

.label-cupom {
  font-size: 12px;
  font-weight: bold;
  color: #40DA99;
}

.codigo-cupom {
  font-family: 'Open Sans', sans-serif;
  font-weight: 800;
  font-size: 20px;
  letter-spacing: 1px;
}

.div-buttons-advertisers {
  margin-left: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 150px;
  /* Garante tamanho para os botões */
}

.div-buttons-advertisers button {
  background: #40DA99;
  color: #2D2F32 !important;
  border-radius: 24px;
  padding: 8px 25px;
  font-weight: bold;
  font-size: 13px;
  border: none;
  cursor: pointer;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);
  width: 100%;
}

.div-buttons-advertisers a {
  text-decoration: none;
  font-size: 12px;
  font-weight: 600;
  color: #40DA99 !important;
  border: 1px solid #40DA99;
  border-radius: 24px;
  padding: 5px 20px;
  width: 100%;
  text-align: center;
}

.theme--dark .div-each-advertiser-bond {
  background: #2D2F32;
  box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.25);
}

.theme--light .div-each-advertiser-bond {
  background: #FFFFFF;
  box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.1);
}

.theme--dark .codigo-cupom {
  color: #FFFFFF !important;
}

.theme--light .codigo-cupom {
  color: #2D2F32 !important;
}

.container-without-shops {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 30vh;
}

.container-without-advertiser {
  border: 1px solid #40DA99;
  padding: 20px;
  border-radius: 24px;
  opacity: 0.7;
}

@media (min-width: 600px) {

  .menu-column {
    flex: 0 0 215px !important;
    max-width: 215px !important;
  }

  .div-container-activeadvertisers-card {
    flex: 1 !important;
    max-width: calc(100% - 215px) !important;
    width: auto !important;
  }
}

@media (max-width: 960px) {
  .div-container-activeadvertisers-card {
    padding-left: 0 !important;
  }
}

@media (max-width: 600px) {
  .div-each-advertiser-bond {
    flex-direction: column;
    text-align: center;
  }

  .div-layout-information-advertiser-bond {
    flex-direction: column;
    margin-bottom: 15px;
  }

  .div-logo-advertiser {
    margin-right: 0;
    margin-bottom: 10px;
  }

  .div-information-each-advertiser {
    text-align: center;
  }

  .div-buttons-advertisers {
    margin-left: 0;
    width: 100%;
  }

  .div-cupom-destaque {
    justify-content: center;
  }
}
</style>